import React from 'react';
import ComponentRegistry from "Fratello/Common/ComponentRegistry";

export default function Choice(props)
{
    if (!props.forceRender && Object.keys(props.choices).length == 1 && typeof props.placeholder === 'undefined') {
        return (
            <div>
                {Object.keys(props.choices).map((value) => {return <label key={value}>
                    <input type="hidden" name={props.name} value={value} /> {props.choices[value]}
                </label>})}
            </div>
        );
    }

    let Component = ComponentRegistry.get(props.expanded ? 'MultiCheckbox' : 'Dropdown');
    return <Component {...props} />
}

Choice.defaultProps = {
    expanded: false,
    multiple: false,
    forceRender: false,
    choices: []
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Atoms/Choice.jsx